export default __webpack_public_path__ + "static/media/O-003.62adeea7.png";